<template>
  <div class="switch-panel-container">
    <v-tooltip bottom content-class="tooltip-dark">
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >Client</span>
      </template>
      <span class="tooltip-text">Switch to Client Panel</span>
    </v-tooltip>
    <v-switch v-model="isPanelActive" @change="switchToClientPanel" color="white" hide-details></v-switch>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'PanelSwitcher',
  data() {
    return {
      isPanelActive: false
    }
  },
  methods: {
    ...mapActions('authentication', ['switchToClientPanel'])
  }
}
</script>

<style scoped>
.switch-panel-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  margin-right: 40px;
}

@media(max-width: 767.98px) {
  .switch-panel-container {
    margin: 0;
  }
}
</style>